import { Pipe, PipeTransform } from '@angular/core';
import { ApplicationService } from './application.service';

@Pipe({
  name: 'power'
})
export class PowerPipe implements PipeTransform {

  constructor (private appService: ApplicationService) {}

  transform(value: unknown, powerValue: unknown): unknown {
    if (this.appService.isBrandPower())
      return powerValue;
    else
      return value;
  }

}
